module.exports = __webpack_public_path__ + "static/media/18ECA40.877352e0.jpg";